 
import { makeRequest } from '../../../../lib/api';
import {
  PartnerServicePrioritiesRequestInterface,
  PartnerServicePrioritiesUpdateInterface,
} from './partnerServices';

const SERVICE_PARTNER_PATH = '/v1/service_partner';

export const partnerServiceController = {

  getPartnerPriorities: (data: PartnerServicePrioritiesRequestInterface): Promise<any> => {
    return makeRequest('get', `${ SERVICE_PARTNER_PATH }/priorities?fiasId=${ data.fiasId }&serviceId=${ data.serviceId }`);
  },

  updatePartnerPriorities: (data: PartnerServicePrioritiesUpdateInterface): Promise<any> => {
    return makeRequest('put', `${ SERVICE_PARTNER_PATH }/priority`, data);
  },

};
